export var dbdutil_get_cookie_domain = function() {
  var domain = document.domain;

  if ( domain.substr( 0, 4 ) === 'www.' ) {
    domain = domain.slice(4);
  }

  return domain;
}
